module.exports = __webpack_public_path__ + "img/girl.024a6e20.jpg";